import React, { useState } from "react";
import axios from "../../Utils/axios";
import { Button, Typography, Alert, Grid } from "@mui/material";
import { Row, Form, FormGroup, Col, Input } from "reactstrap";
import pin from "../../Assets/images/pin-contact-page-matching-plt.png";
import mail from "../../Assets/images/email-contact-page-matching-plt.png";
import phone from "../../Assets/images/phone-contact-page-matching-plt.png";
import "./Contact.css";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

function Contact() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    service_type: "",
    name: "",
    email: "",
    tel: "",
    content: "",
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/public/s/c/contact", formData);
      console.log(response.data);

      setFormSubmitted(true);

      Swal.fire({
        title: t("message_sent_title"),
        text: t("message_sent_text"),
        icon: "success",
        confirmButtonText: t("ok"),
        customClass: { confirmButton: "swal2-confirm-button" },
      }).then(() => window.location.reload());
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: t("error"),
        text: t("error_try_again"),
        icon: "error",
        confirmButtonText: t("ok"),
      });
    }
  };

  return (
    <div>
      <section className="bg-section-contact">
        <Grid style={{ paddingBottom: "100px" }}>
          <Typography
            variant="h1"
            sx={{ color: "#3F4C52", textAlign: "center", fontFamily: "DM Serif Display", fontSize: { xs: "7.5vw", md: "4.5vw" }, fontWeight: 400 }}
          >
            {t("contact_us")}
          </Typography>
        </Grid>

        <Grid container spacing={4} justifyContent="center" alignItems="center">
          {/* Adresse */}
          <Grid item xs={12} sm={6} md={4} style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <img src={pin} alt={t("address")} style={{ width: "15%", margin: "auto", height: "auto" }} />
            <Typography variant="h4" sx={{ color: "#3F4C52", textAlign: "center", fontFamily: "Lato", fontSize: { xs: "14px", sm: "16px", md: "18px", lg: "20px" }, fontWeight: 400, marginTop: "30px", marginBottom: "50px" }}>
              {t("perpignan_france")}
            </Typography>
          </Grid>

          {/* Email */}
          <Grid item xs={12} sm={6} md={4} style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <img src={mail} alt={t("email")} style={{ width: "15%", margin: "auto", height: "auto" }} />
            <Typography variant="h4" sx={{ color: "#3F4C52", textAlign: "center", fontFamily: "Lato", fontSize: { xs: "14px", sm: "16px", md: "18px", lg: "20px" }, fontWeight: 400, marginTop: "30px", marginBottom: "50px", wordBreak: "break-word" }}>
              contact@yanacom.fr
            </Typography>
          </Grid>

          {/* Téléphone */}
          <Grid item xs={12} sm={6} md={4} style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <img src={phone} alt={t("phone")} style={{ width: "15%", margin: "auto", height: "auto" }} />
            <Typography variant="h4" sx={{ color: "#3F4C52", textAlign: "center", fontFamily: "Lato", fontSize: { xs: "14px", sm: "16px", md: "18px", lg: "20px" }, fontWeight: 400, marginTop: "30px", marginBottom: "50px" }}>
              +33 (0) 6 60 22 71 75
            </Typography>
          </Grid>
        </Grid>

        {/* Formulaire */}
        <Row>
          <Col xs="12" className="form-style">
            <Form onSubmit={handleSubmit}>
              <FormGroup row>
                <Col sm={12}>
                  <Input name="service_type" type="select" onChange={handleChange} value={formData.service_type} style={{ border: "1px solid #4AAE9B", borderRadius: "35px" }}>
                    <option value="">{t("select_service_type")}</option>
                    <option value="Service client">{t("customer_service")}</option>
                    <option value="Service commercial">{t("sales_service")}</option>
                    <option value="Service réclamation">{t("claims_service")}</option>
                  </Input>
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={12}>
                  <Input name="name" type="text" placeholder={t("full_name")} onChange={handleChange} value={formData.name} style={{ border: "1px solid #4AAE9B", borderRadius: "35px" }} />
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={12}>
                  <Input name="tel" type="tel" placeholder={t("phone")} onChange={handleChange} value={formData.tel} style={{ border: "1px solid #4AAE9B", borderRadius: "35px" }} />
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={12}>
                  <Input name="email" type="email" placeholder={t("email")} onChange={handleChange} value={formData.email} style={{ border: "1px solid #4AAE9B", borderRadius: "35px" }} />
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={12}>
                  <Input name="content" type="textarea" placeholder={t("your_message")} onChange={handleChange} value={formData.content} style={{ border: "1px solid #4AAE9B", borderRadius: "35px" }} />
                </Col>
              </FormGroup>

              <Button type="submit" sx={{
                backgroundColor: "#4AAE9B", color: "white", textTransform: "none", float: "right", fontFamily: "Lato", fontSize: "18px", padding: "10px 20px", borderRadius: "35px",
                transition: "background-color 0.3s ease", '&:hover': { backgroundColor: "#A8C9B0" }
              }}>
                {t("send")}
              </Button>
            </Form>

            {formSubmitted && (
              <div style={{ marginTop: "20px" }}>
                <Alert severity="success">{t("message_sent_success")}</Alert>
              </div>
            )}
          </Col>
        </Row>
      </section>
    </div>
  );
}

export default Contact;